import * as React from "react"
import { SVGProps, memo } from "react"

const CheckMarkWide = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 52 37" fill="none" {...props}>
    <path
      d="M16.302 29.192L4.142 17.686 0 21.576 16.302 37 51.297 3.89 47.185 0 16.302 29.192z"
      fill="#fff"
    />
  </svg>
)

const MemoCheckMarkWide = memo(CheckMarkWide)
export default MemoCheckMarkWide
